import KunLoading115 from './src/index'

KunLoading115.install = function (Vue) {
	Vue.component(KunLoading115.name, KunLoading115);
}

export default KunLoading115;
